import React from 'react'

import EditSectionsList from '../../../../../features/components/Forms/EditForm/EditSectionsList'

import { useGoogleCampaignBudgetEditSections } from './useGoogleCampaignBudgetEditSections'

const GoogleEditSections = ({ campaign, isEditDataLoading }) => {
  const { editSections, sectionsInitialOpenStates } = useGoogleCampaignBudgetEditSections(campaign?.id)

  return (
    <EditSectionsList
      editSections={editSections}
      isEditDataLoading={isEditDataLoading}
      editItemData={campaign}
      sectionsInitialOpenStates={sectionsInitialOpenStates}
    />
  )
}

export default GoogleEditSections
